import { gql } from "@apollo/client";

export const createKeywordGroup = gql`
  mutation CreateKeywordGroup(
    $name: String!
    $slug: String!
    $type: KeywordGroupType!
    $keywords: [String!]!
    $imageUrl: String
  ) {
    createKeywordGroup(
      name: $name
      slug: $slug
      type: $type
      keywords: $keywords
      imageUrl: $imageUrl
    ) {
      id
      name
      slug
      imageUrl
      type
      keywords
      keywordsGroupIds
      deleted
      metadata
    }
  }
`;
